<h2 mat-dialog-title>{{ 'filterDialog.titol' | translate }}</h2>

<mat-dialog-content class="dialog-content">
  <div [ngSwitch]="data.type">

    <div *ngSwitchCase="'text'">
      <div class="toggle-group">
        <label>
          <input type="radio" name="mode" value="ANY" [(ngModel)]="data.mode"> {{ 'filterDialog.orLikeAny' | translate }}
        </label>
        <label>
          <input type="radio" name="mode" value="ALL" [(ngModel)]="data.mode"> {{ 'filterDialog.andLikeAll' | translate }}
        </label>
      </div>

      <div class="chips-container" style="margin-top:15px">
        <span class="chip" *ngFor="let v of data.values; let i = index">
          {{v}}
          <button type="button" class="chip-remove" (click)="removeValue(i)">✖</button>
        </span>

        <div class="button_petit" style="margin-top:5px">
          <input type="text" placeholder="{{ 'filterDialog.afegeixCondicio' | translate }}" [(ngModel)]="newValue" 
                 (keyup.enter)="addValue()" style="width:85%; padding:5px;">
          <button mat-icon-button color="primary" (click)="addValue()">
            <mat-icon>check</mat-icon>
          </button>
        </div>
      </div>
    </div>

    <div *ngSwitchCase="'value'" class="filter-section">
      <p class="section-label">{{ 'filterDialog.defineixRang' | translate }}</p>
      <div class="input-row">
        <mat-form-field appearance="outline" class="flex-1">
          <mat-label>{{ 'filterDialog.minim' | translate }}</mat-label>
          <input matInput type="number" [(ngModel)]="data.min" placeholder="{{ 'filterDialog.minimPlaceholder' | translate }}" style="width:100px;margin-left:5px">
          <span matPrefix style="margin-right: 8px;margin-left:5px">&ge;</span>
        </mat-form-field>

        <mat-form-field appearance="outline" class="flex-1">
          <mat-label>{{ 'filterDialog.maxim' | translate }}</mat-label>
          <input matInput type="number" [(ngModel)]="data.max" placeholder="{{ 'filterDialog.maximPlaceholder' | translate }}" style="width:100px;margin-left:5px">
          <span matPrefix style="margin-right: 8px;margin-left:5px">&le;</span>
        </mat-form-field>
      </div>
    </div>

    <div *ngSwitchCase="'date'" class="filter-section">
      <p class="section-label">{{ 'filterDialog.seleccionaPeriode' | translate }}</p>
      <div class="input-row">
        <mat-form-field appearance="outline" class="flex-1">
          <mat-label>{{ 'filterDialog.desDe' | translate }}</mat-label>
          <input matInput [matDatepicker]="pickerStart" [(ngModel)]="data.dateStart" style="width:50px;margin-left:5px">
          <mat-datepicker-toggle matSuffix [for]="pickerStart"></mat-datepicker-toggle>
          <mat-datepicker #pickerStart></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline" class="flex-1">
          <mat-label>{{ 'filterDialog.finsA' | translate }}</mat-label>
          <input matInput [matDatepicker]="pickerEnd" [(ngModel)]="data.dateEnd" style="width:50px;margin-left:5px">
          <mat-datepicker-toggle matSuffix [for]="pickerEnd"></mat-datepicker-toggle>
          <mat-datepicker #pickerEnd></mat-datepicker>
        </mat-form-field>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close (click)="tancar()"><mat-icon>close</mat-icon></button>
  <button mat-raised-button color="primary" [mat-dialog-close]="data" style="margin-left: 5px"><mat-icon>check</mat-icon></button>
</mat-dialog-actions>
